export default __webpack_public_path__ + "static/media/Tumult's Veil.2725136b.jpg";